import Alpine from 'alpinejs';

function sizeGuideTabs() {
  return {
    /* Data (State) */
    currentIndex: 0,
  };
}

export default ($section) => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('fitLandingSizeGuideTabs', sizeGuideTabs);
  });
};
